import { isEmptyValue, normalizeSheetRows } from "./payloadRows";

export const resolveRoomDefinitionListOrder = (
  value: unknown,
  index: number,
): number => {
  if (isEmptyValue(value) || value === 0 || value === "0") {
    return index + 1;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.trunc(parsed) : index + 1;
};

export const mapRoomDefinitionExportRows = (
  sheetData: unknown,
): Record<string, unknown>[] =>
  normalizeSheetRows(sheetData).map((row, index) => ({
    ...row,
    listOrder: resolveRoomDefinitionListOrder(row.listOrder, index),
  }));
